import {
  filter_all,
  filter_last_30_days,
  filter_last_month,
  filter_last_week,
  filter_this_month,
  filter_this_week,
  filter_today,
  filter_yesterday,
} from '../../../../../components/filters/DateRangePicker';

export default {
  filters: {
    [filter_today]: 'Oggi',
    [filter_yesterday]: 'Ieri',
    [filter_this_week]: 'Questa settimana',
    [filter_last_week]: 'Settimana scorsa',
    [filter_this_month]: 'Questo mese',
    [filter_last_month]: 'Mese scorso',
    [filter_last_30_days]: 'Ultimi 30 giorni',
    [filter_all]: 'Tutti',
  },
};
